import { Component, OnInit, Input } from "@angular/core";
import { KreFormAntService } from "../tools/service";

import { KreFormFieldConfig } from "@kre-form/core";

@Component({
  selector: "krefield-private_text",
  template: ``,
})
export class KreFormFieldPrivateText implements OnInit {
  service: any;
  @Input() field: KreFormFieldConfig = {};
  @Input() status: number = 1;
  constructor(dyService: KreFormAntService) {
    this.service = dyService;
  }
  ngOnInit() {}
  fieldOperational(sign: string) {
    this.service.fieldOperational(sign, this.field);
  }
}
/*
<ng-container *ngIf="status == 1">
      <div class="fieldOperational">
        <div class="fieldcheckbox">
          <label nz-checkbox [(ngModel)]="field.checked"></label>
        </div>
        <div class="fieldControl">
          <div class="label">
            <span *ngIf="field.templateOptions.required">*</span
            >{{ field.templateOptions.label }}
          </div>
          <div class="control">
            <input nz-input disabled />
          </div>
          <div class="fieldButton">
            <button class="btnEdit" (click)="fieldOperational('edit')">
              <i class="icon-Edit03"></i>编辑
            </button>
            <button class="btnDel" (click)="fieldOperational('delete')">
              <i class="icon-KT-Close"></i>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="status == 2">
      <div class="fieldOperational">
        <div class="fieldControl">
          <div class="label">
            <span *ngIf="field.templateOptions.required">*</span
            >{{ field.templateOptions.label }}
          </div>
          <div class="control">
            <input nz-input disabled />
          </div>
          <div class="fieldButton">
            <button class="btnEdit" (click)="fieldOperational('edit')">
              <i class="icon-Edit03"></i>编辑
            </button>
            <button class="btnDel" (click)="fieldOperational('delete')">
              <i class="icon-KT-Close"></i>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
*/
